import { useContext } from "react";
import FactoryContext from "../../contexts/factoryContext";
import useQueryGames from "../queries/useQueryGames";
import useTeams from "./useTeams";

export default function useGames(week) {
  const factory = useContext(FactoryContext);
  const { teams, teamsQuery } = useTeams();
  const gamesQuery = useQueryGames(week);

  let gamesCollection = null;
  if (gamesQuery?.data?.games && teams) {
    gamesCollection = factory.makeGameCollection(gamesQuery.data.games, teams);
  }

  return {
    gamesCollection,
    gamesData: gamesQuery?.data,
    gamesQuery,
    teamsQuery,
  };
}
